var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72021 12.0482C1.90891 12.1391 2.11741 12.1877 2.33086 12.1877H12.6564C12.8106 12.1877 12.9623 12.1623 13.1058 12.1139L9.03181 7.8546C8.81971 8.05815 8.63026 8.2398 8.47216 8.39085C7.92856 8.9109 7.07176 8.9109 6.52816 8.39085C6.34081 8.21175 6.10846 7.98885 5.84641 7.7373L1.72021 12.0482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7399 3.32227C13.1404 3.90022 11.1782 5.79157 9.70776 7.20487L13.8458 11.531C13.9864 11.3083 14.0626 11.0486 14.0626 10.781V4.21852C14.0626 3.89002 13.9477 3.57337 13.7399 3.32227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25366 3.31494C1.04186 3.56724 0.924561 3.88704 0.924561 4.21899V10.7815C0.924561 10.9913 0.971511 11.1964 1.05956 11.3825L5.17031 7.08774C3.73196 5.70459 1.87961 3.91869 1.25366 3.31494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10327 2.8311L7.17597 7.7133C7.35717 7.8867 7.64277 7.8867 7.82397 7.7133C8.98917 6.59865 11.8644 3.8283 12.8967 2.8332C12.8178 2.81955 12.7374 2.8125 12.6562 2.8125H2.33067C2.25402 2.8125 2.17797 2.8188 2.10327 2.8311Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.c625dc347396bc4d33827f9dd022cf82.svg";
export { ForwardRef as ReactComponent };